/**
 * Landing page feature flags.
 *
 * APPS_PUBLISHED — flip to true once the iOS / Android / watch apps are live in the stores.
 * While false the landing page:
 *  - hides the "Keep score without breaking concentration" module and the Get started /
 *    Download app button row (GET STARTED moves under the intro text instead)
 *  - shows the "Coming soon!" module in place of "Download the app"
 *  - shows the simplified footer (Figma 753:14064)
 *  - swaps the DOWNLOAD nav item for SIGN IN
 * Nothing is deleted, so flipping the flag brings everything back.
 */
export const APPS_PUBLISHED = false;

export const INSTAGRAM_URL = 'https://www.instagram.com/padelmvp/';
